import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import hr from "./locales/hr";
import en from "./locales/en";
import de from "./locales/de";

export const LANGUAGE_STORAGE_KEY = "orico-language";
export const supportedLanguages = ["hr", "en", "de"];

function savedLanguage() {
  try {
    const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    return supportedLanguages.includes(stored) ? stored : "hr";
  } catch {
    return "hr";
  }
}

i18n.use(initReactI18next).init({
  resources: { hr: { translation: hr }, en: { translation: en }, de: { translation: de } },
  lng: savedLanguage(),
  fallbackLng: "hr",
  supportedLngs: supportedLanguages,
  interpolation: { escapeValue: false },
  initAsync: false,
});

function rememberLanguage(language) {
  document.documentElement.lang = language;
  try { localStorage.setItem(LANGUAGE_STORAGE_KEY, language); } catch { /* In-memory switching still works. */ }
}

rememberLanguage(i18n.resolvedLanguage || "hr");
i18n.on("languageChanged", rememberLanguage);

export default i18n;